import { Link } from '@tanstack/react-router';
import { useLingui } from '@lingui/react';
import { t } from '@lingui/core/macro';
import ButtonIcon from '../ui/ButtonIcon';
import ThemeLogo from '../ui/ThemeLogo';
import { useMobileNavSidebar } from '../../hooks/useUserPreferences';
import NavItem from './NavItem';

interface SettingsNavItemConfig {
  to: string;
  label: string;
}

function SettingsNavigation() {
  // Subscribe to locale changes to re-render when language changes
  useLingui();
  const { closeMobileNavSidebar } = useMobileNavSidebar();

  // Define nav items inside component so t`` macro works with React context
  const settingsNavItems: SettingsNavItemConfig[] = [
    { to: '/settings/account', label: t`Account` },
    { to: '/settings/profile', label: t`Profile` },
    { to: '/settings/premium', label: t`Premium` },
    { to: '/settings/email', label: t`Email Preferences` },
    { to: '/settings/connected-accounts', label: t`Connected Accounts` },
    { to: '/settings/kindle', label: 'Kindle' },
  ];

  return (
    <nav className="side-nav" aria-label={t`Settings Navigation`}>
      <div className="logo-container hidden md:block">
        <Link to="/home" className="block">
          <ThemeLogo className="app-logo" />
        </Link>
      </div>

      <div className="px-2 pt-4 pb-0 md:pt-0 md:pb-[100px]" data-testid="nav-scroller">
        {/* Mobile close button - only visible on mobile */}
        <div className="mb-4 flex justify-end md:hidden">
          <ButtonIcon
            icon="close"
            title={t`Close`}
            onClick={closeMobileNavSidebar}
            className="text-copy-secondary"
          />
        </div>

        {/* Mobile home link - only visible on mobile */}
        <div className="md:hidden">
          <NavItem to="/home" label={t`Home`} useUrlMatch className="pl-3" />
        </div>

        {settingsNavItems.map((item) => (
          <NavItem
            key={item.to}
            to={item.to}
            label={item.label}
            useUrlMatch
            className="pl-3"
          />
        ))}
      </div>
    </nav>
  );
}

export default SettingsNavigation;
